import React from 'react'
import { Button, Icon, Tooltip } from '@equinor/eds-core-react'
import styled from 'styled-components'

interface IEditButton {
    disabled: boolean
    disabledTooltip?: string
    onClick?: () => void
}

const EditButton: React.FC<IEditButton> = ({ disabled, disabledTooltip, onClick }) => {
    const handleClick = () => {
        onClick?.()
    }

    return (
        <Tooltip title={disabled ? (disabledTooltip ?? '') : ''} placement="top">
            <ButtonSlot>
                <StyledEditsButton variant="ghost" onClick={handleClick} disabled={disabled}>
                    <Icon name="edit"></Icon>Edit
                </StyledEditsButton>
            </ButtonSlot>
        </Tooltip>
    )
}

// Tooltips need a non-disabled wrapper, since disabled buttons do not emit pointer events.
const ButtonSlot = styled.span`
    display: inline-flex;
`

const StyledEditsButton = styled(Button)`
    height: 36px;
    width: 100px;
    display: flex;
    gap: 7px;
    font-family: Equinor;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    border: none;

    &:not(:disabled) {
        color: #007079;
    }

    &:not(:disabled):hover {
        border: none;
        color: #006269ff;
        background: #ddececff;
        border-radius: 4px;
    }
`

export default EditButton
